<template>
  <ItemForm
    v-if="instance"
    :value="instance"
    :breadcrumbs="breadcrumbs"
  >
    <template #actions="{form, fields, isEqual}">
      <VButtonDialog @confirm="remove(fields)">
        Delete
      </VButtonDialog>
      <v-btn
        :disabled="!form || isEqual"
        color="success"
        class="mx-2"
        rounded
        @click="update(fields)"
      >
        Save
      </v-btn>
    </template>
  </ItemForm>
</template>

<script>
import ItemForm from '@/pages/App/MenuCreator/Items/__ItemForm__'
import { Item } from '@/store/models'
import VButtonDialog from '@/components/VButtonDialog'
import removeMixin from '@/mixins/apiRemoveMixin'
import updateMixin from '@/mixins/apiUpdateMixin'
import { mapGetters } from 'vuex'

export default {
  name: 'ItemId',
  components: { ItemForm, VButtonDialog },
  mixins: [removeMixin(Item), updateMixin(Item)],
  computed: {
    ...mapGetters('app', ['items']),
    breadcrumbs () {
      return [
        {
          text: 'Items',
          exact: true,
          to: { name: 'App-MenuCreator-Items' }
        },
        {
          text: this.instance.name,
          exact: true,
          to: { name: 'App-MenuCreator-Items-id', params: { id: this.instance.id } }
        }
      ]
    },
    instance () {
      const item = this.items.find(this.$route.params.id)
      if (item?.itemCustomizers) {
        item.itemCustomizers.sort((x, y) => x.rank - y.rank)
      }
      return item
    }
  }
}
</script>
